export default "assets/images/arch-mask-1a917b91.svg";